import { useMemo } from 'react';
export function useAcsRoomLocator(acsRoomId) {
    return useMemo(() => {
        if (acsRoomId) {
            return { roomId: acsRoomId };
        }
    }, [acsRoomId]);
}
